//component/Geospatial/mockData/GeospatialData.jsx

// Mirrors FACILITY_TYPE_LABELS in api/facilitiesApi.js plus the market-registry
// bucket types (Market/Processing/Abattoir) so every marker on the Geospatial
// Overview map — facility or market record — has a defined colour and icon.
export const FACILITY_TYPES = {
  ABATTOIR: 'Abattoir',
  MARKET: 'Market',
  PROCESSING: 'Processing',
  VETERINARY_CLINIC: 'Veterinary Clinic',
  VETERINARY_HOSPITAL: 'Veterinary Hospital',
  LABORATORY: 'Laboratory',
  DIAGNOSTIC_CENTRE: 'Diagnostic Centre',
  LIVE_ANIMAL_MARKET: 'Live Animal Market',
  SLAUGHTER_SLAB: 'Slaughter Slab',
  GRAZING_RESERVE: 'Grazing Reserve',
  WATERING_POINT: 'Watering Point',
  MILK_COLLECTION_CENTRE: 'Milk Collection Centre',
  FEED_MILL: 'Feed Mill',
  COLD_STORAGE_COMMERCIAL: 'Cold Storage (Commercial)',
  COLD_STORAGE_BIOLOGICAL: 'Cold Storage (Biological)',
  BREEDING_FARM: 'Breeding Farm',
  AI_CENTRE: 'AI Centre',
  QUARANTINE_STATION: 'Quarantine Station',
  RANCH: 'Ranch',
  OTHER: 'Other',
};

export const STATUS_COLORS = {
  Active: '#22c55e',
  Inactive: '#ef4444',
  Pending: '#f59e0b',
};

// Colour palette per facility/market type (marker background + legend dot)
export const TYPE_COLORS = {
  [FACILITY_TYPES.ABATTOIR]: '#ef4444',               // red
  [FACILITY_TYPES.SLAUGHTER_SLAB]: '#f97316',         // orange
  [FACILITY_TYPES.MARKET]: '#f59e0b',                 // amber/gold
  [FACILITY_TYPES.LIVE_ANIMAL_MARKET]: '#f59e0b',     // amber/gold
  [FACILITY_TYPES.VETERINARY_CLINIC]: '#3b82f6',      // blue
  [FACILITY_TYPES.VETERINARY_HOSPITAL]: '#3b82f6',    // blue
  [FACILITY_TYPES.LABORATORY]: '#8b5cf6',             // violet
  [FACILITY_TYPES.DIAGNOSTIC_CENTRE]: '#a855f7',      // purple
  [FACILITY_TYPES.PROCESSING]: '#22c55e',             // green (arrow)
  [FACILITY_TYPES.RANCH]: '#16a34a',                  // darker green (animal)
  [FACILITY_TYPES.GRAZING_RESERVE]: '#65a30d',        // olive green
  [FACILITY_TYPES.BREEDING_FARM]: '#15803d',          // forest green
  [FACILITY_TYPES.WATERING_POINT]: '#06b6d4',         // cyan
  [FACILITY_TYPES.MILK_COLLECTION_CENTRE]: '#ec4899', // pink
  [FACILITY_TYPES.FEED_MILL]: '#0ea5e9',              // sky blue
  [FACILITY_TYPES.COLD_STORAGE_COMMERCIAL]: '#6366f1',  // indigo
  [FACILITY_TYPES.COLD_STORAGE_BIOLOGICAL]: '#4f46e5',  // deep indigo
  [FACILITY_TYPES.AI_CENTRE]: '#d946ef',               // fuchsia
  [FACILITY_TYPES.QUARANTINE_STATION]: '#dc2626',      // dark red
  [FACILITY_TYPES.OTHER]: '#6b7280',                   // grey
};

export const facilities = [
  // ── ABATTOIRS ──────────────────────────────────────────────────────────────
  {
    id: 'a-001',
    name: 'Kano Central Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Kano',
    lga: 'Damsadufa-giri',
    capacity: '500 butchers/day',
    status: 'Active',
    lat: 12.0,
    lng: 8.59,
    description: 'Largest abattoir in the North-West zone, serving the greater Kano metropolis.',
    established: '1987',
    contact: '+234 64 123 456',
  },
  {
    id: 'a-002',
    name: 'Kaduna Modern Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Kaduna',
    lga: 'Kaduna North',
    capacity: '350 butchers/day',
    status: 'Active',
    lat: 10.52,
    lng: 7.44,
    description: 'State-of-the-art facility with cold-chain storage.',
    established: '2003',
    contact: '+234 62 234 567',
  },
  {
    id: 'a-003',
    name: 'Jos Plateau Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Plateau',
    lga: 'Jos North',
    capacity: '280 butchers/day',
    status: 'Active',
    lat: 9.92,
    lng: 8.89,
    description: 'Primary slaughter facility for the Plateau State region.',
    established: '1995',
    contact: '+234 73 345 678',
  },
  {
    id: 'a-004',
    name: 'Abuja Municipal Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'FCT',
    lga: 'Abuja Municipal',
    capacity: '400 butchers/day',
    status: 'Active',
    lat: 9.07,
    lng: 7.49,
    description: 'Serves the Federal Capital Territory demand.',
    established: '2001',
    contact: '+234 9 456 789',
  },
  {
    id: 'a-005',
    name: 'Minna Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Niger',
    lga: 'Chanchaga',
    capacity: '200 butchers/day',
    status: 'Inactive',
    lat: 9.61,
    lng: 6.55,
    description: 'Undergoing renovation, expected to reopen Q3.',
    established: '1990',
    contact: '+234 66 567 890',
  },
  {
    id: 'a-006',
    name: 'Bauchi Central Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Bauchi',
    lga: 'Bauchi',
    capacity: '320 butchers/day',
    status: 'Active',
    lat: 10.31,
    lng: 9.84,
    description: 'Serves the North-East corridor.',
    established: '1998',
    contact: '+234 77 678 901',
  },
  {
    id: 'a-007',
    name: 'Taraba Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Taraba',
    lga: 'Jalingo',
    capacity: '180 butchers/day',
    status: 'Active',
    lat: 8.89,
    lng: 11.37,
    description: 'Key facility for the Taraba State meat supply chain.',
    established: '2008',
    contact: '+234 79 789 012',
  },
  {
    id: 'a-008',
    name: 'Makurdi Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Benue',
    lga: 'Makurdi',
    capacity: '220 butchers/day',
    status: 'Pending',
    lat: 7.73,
    lng: 8.52,
    description: 'Expansion project pending regulatory approval.',
    established: '2005',
    contact: '+234 44 890 123',
  },
  {
    id: 'a-009',
    name: 'Enugu Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Enugu',
    lga: 'Enugu North',
    capacity: '300 butchers/day',
    status: 'Active',
    lat: 6.45,
    lng: 7.51,
    description: 'South-East hub for livestock processing.',
    established: '1993',
    contact: '+234 42 901 234',
  },
  {
    id: 'a-010',
    name: 'Ado-Ekiti Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Ekiti',
    lga: 'Ado-Ekiti',
    capacity: '150 butchers/day',
    status: 'Active',
    lat: 7.63,
    lng: 5.22,
    description: 'Serves Ekiti and surrounding states.',
    established: '2010',
    contact: '+234 30 012 345',
  },
  {
    id: 'a-011',
    name: 'Funtua Abattoir',
    type: FACILITY_TYPES.ABATTOIR,
    state: 'Katsina',
    lga: 'Funtua',
    capacity: '210 butchers/day',
    status: 'Active',
    lat: 11.52,
    lng: 7.31,
    description: 'Strategically positioned on the Kano-Katsina corridor.',
    established: '2000',
    contact: '+234 65 123 456',
  },

  // ── MARKETS ────────────────────────────────────────────────────────────────
  {
    id: 'm-001',
    name: 'Gombe Livestock Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Gombe',
    lga: 'Gombe',
    capacity: '2,000 animals/week',
    status: 'Active',
    lat: 10.29,
    lng: 11.17,
    tradingDays: 'Monday, Thursday',
    description: 'Largest livestock market in the North-East.',
    established: '1975',
    contact: '+234 72 111 222',
  },
  {
    id: 'm-002',
    name: 'Jalingo Cattle Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Taraba',
    lga: 'Jalingo',
    capacity: '1,200 animals/week',
    status: 'Active',
    lat: 8.87,
    lng: 11.42,
    tradingDays: 'Tuesday, Friday',
    description: 'Key trading hub for cattle from the Mambilla Plateau.',
    established: '1982',
    contact: '+234 79 222 333',
  },
  {
    id: 'm-003',
    name: 'Kano Dawanau Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Kano',
    lga: 'Tarauni',
    capacity: '3,000 animals/week',
    status: 'Active',
    lat: 12.05,
    lng: 8.62,
    tradingDays: 'Daily',
    description: 'One of the largest livestock markets in West Africa.',
    established: '1960',
    contact: '+234 64 333 444',
  },
  {
    id: 'm-004',
    name: 'Kaduna Kawo Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Kaduna',
    lga: 'Igabi',
    capacity: '1,800 animals/week',
    status: 'Active',
    lat: 10.55,
    lng: 7.41,
    tradingDays: 'Wednesday, Saturday',
    description: 'Central Kaduna livestock trading point.',
    established: '1978',
    contact: '+234 62 444 555',
  },
  {
    id: 'm-005',
    name: 'Jos Terminus Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Plateau',
    lga: 'Jos North',
    capacity: '900 animals/week',
    status: 'Pending',
    lat: 9.88,
    lng: 8.93,
    tradingDays: 'Saturday',
    description: 'Undergoing infrastructure upgrade.',
    established: '1988',
    contact: '+234 73 555 666',
  },
  {
    id: 'm-006',
    name: 'Abuja Karimo Market',
    type: FACILITY_TYPES.MARKET,
    state: 'FCT',
    lga: 'Abuja Municipal',
    capacity: '1,100 animals/week',
    status: 'Active',
    lat: 9.05,
    lng: 7.42,
    tradingDays: 'Monday, Friday',
    description: 'Primary livestock market for FCT residents.',
    established: '2006',
    contact: '+234 9 666 777',
  },
  {
    id: 'm-007',
    name: 'Wukari Livestock Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Taraba',
    lga: 'Wukari',
    capacity: '700 animals/week',
    status: 'Active',
    lat: 7.87,
    lng: 9.78,
    tradingDays: 'Thursday',
    description: 'Serves the Wukari agricultural belt.',
    established: '1992',
    contact: '+234 79 777 888',
  },
  {
    id: 'm-008',
    name: 'Enugu Ogbete Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Enugu',
    lga: 'Enugu North',
    capacity: '800 animals/week',
    status: 'Active',
    lat: 6.44,
    lng: 7.48,
    tradingDays: 'Tuesday, Saturday',
    description: 'Main livestock section of the Ogbete main market.',
    established: '1970',
    contact: '+234 42 888 999',
  },
  {
    id: 'm-009',
    name: 'Gashaka Border Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Taraba',
    lga: 'Gashaka',
    capacity: '600 animals/week',
    status: 'Active',
    lat: 7.91,
    lng: 11.54,
    tradingDays: 'Friday',
    description: 'Cross-border livestock trade with Cameroon.',
    established: '1985',
    contact: '+234 79 999 000',
  },
  {
    id: 'm-010',
    name: 'Minna Monday Market',
    type: FACILITY_TYPES.MARKET,
    state: 'Niger',
    lga: 'Bosso',
    capacity: '950 animals/week',
    status: 'Active',
    lat: 9.65,
    lng: 6.54,
    tradingDays: 'Monday',
    description: 'Longstanding livestock market in Niger State capital.',
    established: '1973',
    contact: '+234 66 000 111',
  },

  // ── VETERINARY CLINICS ─────────────────────────────────────────────────────
  {
    id: 'v-001',
    name: 'Borno Veterinary Clinic',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Borno',
    lga: 'Damsadufa-giri',
    capacity: '500 butchers/day',
    services: 'Vaccination center',
    status: 'Active',
    lat: 11.83,
    lng: 13.15,
    description: 'Primary animal health centre for Borno State.',
    established: '2002',
    contact: '+234 76 111 222',
  },
  {
    id: 'v-002',
    name: 'Kaduna State Vet Hospital',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Kaduna',
    lga: 'Kaduna South',
    capacity: '200 animals/day',
    services: 'Surgery, Vaccination, Diagnostics',
    status: 'Active',
    lat: 10.5,
    lng: 7.45,
    description: 'Full-service veterinary hospital with lab.',
    established: '1990',
    contact: '+234 62 222 333',
  },
  {
    id: 'v-003',
    name: 'Niger State Vet Clinic',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Niger',
    lga: 'Chanchaga',
    capacity: '150 animals/day',
    services: 'Vaccination, Deworming',
    status: 'Active',
    lat: 9.62,
    lng: 6.58,
    description: 'Community vet clinic serving Minna environs.',
    established: '2007',
    contact: '+234 66 333 444',
  },
  {
    id: 'v-004',
    name: 'Plateau Livestock Vet Centre',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Plateau',
    lga: 'Jos South',
    capacity: '180 animals/day',
    services: 'Disease Surveillance, Vaccination',
    status: 'Active',
    lat: 9.82,
    lng: 8.92,
    description: 'Handles disease outbreak response in Plateau State.',
    established: '2001',
    contact: '+234 73 444 555',
  },
  {
    id: 'v-005',
    name: 'FCT Animal Health Centre',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'FCT',
    lga: 'Abuja Municipal',
    capacity: '250 animals/day',
    services: 'Vaccination, Quarantine',
    status: 'Active',
    lat: 9.04,
    lng: 7.46,
    description: 'National capital veterinary support facility.',
    established: '2004',
    contact: '+234 9 555 666',
  },
  {
    id: 'v-006',
    name: 'Benue Vet Services Clinic',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Benue',
    lga: 'Makurdi',
    capacity: '130 animals/day',
    services: 'Vaccination, Diagnostics',
    status: 'Pending',
    lat: 7.71,
    lng: 8.55,
    description: 'New facility awaiting full accreditation.',
    established: '2022',
    contact: '+234 44 666 777',
  },
  {
    id: 'v-007',
    name: 'Enugu Vet Diagnostic Lab',
    type: FACILITY_TYPES.VETERINARY_CLINIC,
    state: 'Enugu',
    lga: 'Enugu East',
    capacity: '100 samples/day',
    services: 'Diagnostics, Disease Mapping',
    status: 'Active',
    lat: 6.46,
    lng: 7.55,
    description: 'Specialised in livestock disease diagnostics.',
    established: '2015',
    contact: '+234 42 777 888',
  },

  // ── PROCESSING ─────────────────────────────────────────────────────────────
  {
    id: 'p-001',
    name: 'Kano Meat Processing Plant',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Kano',
    lga: 'Fagge',
    capacity: '10 tons/day',
    status: 'Active',
    lat: 12.02,
    lng: 8.55,
    certifications: 'NAFDAC, ISO 22000',
    description: 'Produces packaged beef and by-products for retail.',
    established: '2012',
    contact: '+234 64 888 999',
  },
  {
    id: 'p-002',
    name: 'Kaduna Leather Works',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Kaduna',
    lga: 'Kaduna North',
    capacity: '5 tons/day',
    status: 'Active',
    lat: 10.53,
    lng: 7.38,
    certifications: 'NAFDAC',
    description: 'Leather tanning and by-product processing from abattoir waste.',
    established: '2008',
    contact: '+234 62 999 000',
  },
  {
    id: 'p-003',
    name: 'Bauchi Meat Factory',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Bauchi',
    lga: 'Bauchi',
    capacity: '8 tons/day',
    status: 'Active',
    lat: 10.32,
    lng: 9.81,
    certifications: 'NAFDAC, Halal',
    description: 'Halal-certified meat processing with cold storage.',
    established: '2014',
    contact: '+234 77 000 111',
  },
  {
    id: 'p-004',
    name: 'Jos Processing Hub',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Plateau',
    lga: 'Jos East',
    capacity: '6 tons/day',
    status: 'Active',
    lat: 9.95,
    lng: 8.95,
    certifications: 'NAFDAC',
    description: 'Livestock by-product processing and value addition.',
    established: '2016',
    contact: '+234 73 111 222',
  },
  {
    id: 'p-005',
    name: 'Abuja Processing Centre',
    type: FACILITY_TYPES.PROCESSING,
    state: 'FCT',
    lga: 'Abuja Municipal',
    capacity: '12 tons/day',
    status: 'Active',
    lat: 9.09,
    lng: 7.44,
    certifications: 'NAFDAC, ISO 22000, Halal',
    description: 'Premium meat processing for FCT supermarkets.',
    established: '2018',
    contact: '+234 9 222 333',
  },
  {
    id: 'p-006',
    name: 'Taraba Agro-Processing',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Taraba',
    lga: 'Jalingo',
    capacity: '4 tons/day',
    status: 'Inactive',
    lat: 8.92,
    lng: 11.35,
    certifications: 'NAFDAC',
    description: 'Equipment upgrade in progress.',
    established: '2011',
    contact: '+234 79 333 444',
  },
  {
    id: 'p-007',
    name: 'Ado-Ekiti Processing Unit',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Ekiti',
    lga: 'Ado-Ekiti',
    capacity: '3 tons/day',
    status: 'Active',
    lat: 7.62,
    lng: 5.24,
    certifications: 'NAFDAC',
    description: 'South-West small-scale meat processing unit.',
    established: '2019',
    contact: '+234 30 444 555',
  },
  {
    id: 'p-008',
    name: 'Enugu South Processing',
    type: FACILITY_TYPES.PROCESSING,
    state: 'Enugu',
    lga: 'Enugu South',
    capacity: '5 tons/day',
    status: 'Active',
    lat: 6.42,
    lng: 7.53,
    certifications: 'NAFDAC, ISO 9001',
    description: 'Serves South-East distribution network.',
    established: '2013',
    contact: '+234 42 555 666',
  },

  // ── RANCHES ────────────────────────────────────────────────────────────────
  {
    id: 'r-001',
    name: 'Zamfara State Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Zamfara',
    lga: 'Zuru',
    capacity: '5,000 cattle',
    status: 'Active',
    lat: 12.1,
    lng: 6.25,
    breeds: 'Bunaji, Sokoto Gudali',
    description: 'One of the largest government-owned ranches in the North-West.',
    established: '1968',
    contact: '+234 63 111 222',
  },
  {
    id: 'r-002',
    name: 'Kaduna Cattle Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Kaduna',
    lga: 'Kaura',
    capacity: '3,200 cattle',
    status: 'Active',
    lat: 10.48,
    lng: 7.5,
    breeds: 'White Fulani, Bunaji',
    description: 'Private ranch with breed improvement programme.',
    established: '1995',
    contact: '+234 62 222 333',
  },
  {
    id: 'r-003',
    name: 'Kano Integrated Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Kano',
    lga: 'Rogo',
    capacity: '4,500 cattle',
    status: 'Active',
    lat: 11.85,
    lng: 8.72,
    breeds: 'Sokoto Gudali, Bunaji',
    description: 'Integrated livestock and crop production facility.',
    established: '2001',
    contact: '+234 64 333 444',
  },
  {
    id: 'r-004',
    name: 'Plateau Highland Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Plateau',
    lga: 'Mangu',
    capacity: '2,800 cattle',
    status: 'Active',
    lat: 10.02,
    lng: 9.05,
    breeds: 'White Fulani, Cross breeds',
    description: 'Highland ranching with cool-climate cattle breeds.',
    established: '1988',
    contact: '+234 73 444 555',
  },
  {
    id: 'r-005',
    name: 'Gombe Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Gombe',
    lga: 'Nafada',
    capacity: '2,100 cattle',
    status: 'Active',
    lat: 10.34,
    lng: 11.22,
    breeds: 'Bunaji',
    description: 'Government-supported ranch with veterinary outpost.',
    established: '1975',
    contact: '+234 72 555 666',
  },
  {
    id: 'r-006',
    name: 'Niger State Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Niger',
    lga: 'Lapai',
    capacity: '3,800 cattle',
    status: 'Active',
    lat: 9.03,
    lng: 6.57,
    breeds: "Sokoto Gudali, N'dama",
    description: 'Largest ranch in Niger State with irrigation for fodder.',
    established: '1972',
    contact: '+234 66 666 777',
  },
  {
    id: 'r-007',
    name: 'Benue Tse-Agberagba Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Benue',
    lga: 'Gboko',
    capacity: '1,900 cattle',
    status: 'Active',
    lat: 7.32,
    lng: 9.0,
    breeds: 'White Fulani, Tiv cross',
    description: 'Community-owned ranch operated under cooperative model.',
    established: '2006',
    contact: '+234 44 777 888',
  },
  {
    id: 'r-008',
    name: 'Ekiti Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Ekiti',
    lga: 'Ikole',
    capacity: '1,200 cattle',
    status: 'Active',
    lat: 7.55,
    lng: 5.5,
    breeds: "N'dama, Muturu",
    description: 'South-West trypanotolerant breed ranch.',
    established: '2010',
    contact: '+234 30 888 999',
  },
  {
    id: 'r-009',
    name: 'Taraba Mambilla Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Taraba',
    lga: 'Sardauna',
    capacity: '6,000 cattle',
    status: 'Active',
    lat: 7.6,
    lng: 11.65,
    breeds: 'Gudali, Friesian crosses',
    description: 'Highest altitude cattle ranch in Nigeria on Mambilla Plateau.',
    established: '1963',
    contact: '+234 79 999 000',
  },
  {
    id: 'r-010',
    name: 'Wukari Valley Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Taraba',
    lga: 'Wukari',
    capacity: '1,600 cattle',
    status: 'Active',
    lat: 7.85,
    lng: 9.85,
    breeds: 'White Fulani',
    description: 'Valley ranch with river-fed paddocks.',
    established: '2015',
    contact: '+234 79 000 111',
  },
  {
    id: 'r-011',
    name: 'Enugu Dairy Ranch',
    type: FACILITY_TYPES.RANCH,
    state: 'Enugu',
    lga: 'Oji River',
    capacity: '800 cattle',
    status: 'Active',
    lat: 6.48,
    lng: 7.35,
    breeds: 'Friesian, Bunaji cross',
    description: 'Dairy-focused ranch supplying local milk processors.',
    established: '2017',
    contact: '+234 42 111 222',
  },
];

// Helper: filter facilities by type
export const getFacilitiesByType = (type) =>
  type ? facilities.filter((f) => f.type === type) : facilities;

// Helper: get a facility by id
export const getFacilityById = (id) => facilities.find((f) => f.id === id);